import { LitElement, html } from 'lit-element';

class UnderlyingOverviewItem extends LitElement {
	static get properties() {
		return {
			data: { type: Array },
		};
	}

	render() {
		const { data } = this;

		return html`
			<div class="table__cell">
				<a href="${data.url}" class="underlying-overview__anchor">
					${data.underlyingName}
				</a>
			</div>
			<div class="table__cell text-right">
				${data.productCount}
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-underlying-overview-item', UnderlyingOverviewItem);

export default UnderlyingOverviewItem;
